import { OfficesService } from './../../services/offices.service';
import { Office } from './../../models/office.model';
import { PropertiesService } from './../../services/properties.service';
import { Category } from './../../components/generics/data-printer/data-printer.component';
import { Commission } from './../../models/commission.model';
import { User } from './../../models/user.model';
import { UtilsService } from './../../services/utils.service';
import { ErrorResponse } from './../../models/error.model';
import { QuotesService } from './../../services/quotes.service';
import { ProductType } from './../../models/product.model';
import { AuthService } from './../../services/auth.service';
import { Service } from './../../models/service.model';
import { MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators, FormControl } from '@angular/forms';
import { SelectOption } from '../../models/select-option.model';
import { QuotationService, Quote, QuoteType } from '../../models/quote.model';
import { ID } from '../../models/ID.model';
import { Currency } from 'src/app/models/currency.model';
import { TiposFianzaService } from '../../services/tipos-fianza.service';
import { TipoFianza, TipoProducto } from '../../models/tipo-fianza.model';
import { SERVICIOS_POR_CLAVE } from '../../components/quotes/new-quote/new-quote.component';
import { ZonasService } from '../../services/zonas.service';
import { Zona } from '../../models/zona.model';
import { TiposDescuentoService } from '../../services/tipos-descuento.service';
import { TipoDescuento } from '../../models/tipo-descuento.model';
import { ComercialesService } from '../../services/comerciales.service';
import { Comercial } from '../../models/comercial.model';

@Component({
    selector: 'app-fast-quote-dialog',
    templateUrl: './fast-quote-dialog.component.html',
    styleUrls: ['./fast-quote-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FastQuoteDialogComponent implements OnInit {

    quoteFG = new UntypedFormGroup({
        oficina: new UntypedFormControl('', []),
        tipoProducto: new UntypedFormControl('GARANTIA', [Validators.required]),
        tipo: new UntypedFormControl('VIVIENDA', [Validators.required]),
        idZona: new UntypedFormControl(null, []),
        idTipoFianza: new UntypedFormControl(null, [Validators.required]),
        alquiler: new UntypedFormControl('', [Validators.required]),
        monedaAlquiler: new FormControl<string | undefined>('ARS', []),
        expensas: new UntypedFormControl('', [Validators.required]),
        monedaExpensas: new FormControl<string | undefined>('ARS', []),
        tipoCambio: new UntypedFormControl('', []),
        duracion: new UntypedFormControl(36, [Validators.required]),
        actualizacion: new UntypedFormControl(null, []),
        periodoActualizacion: new UntypedFormControl(null, []),
        tipoActualizacion: new UntypedFormControl('MANUAL', []),
        tipoActualizacionCustom: new UntypedFormControl('', []),
        idTipoDescuento: new UntypedFormControl(null, []),
        porcentajeRenovacion: new UntypedFormControl('', []),
        idComercial: new UntypedFormControl(null, []),
        nombre: new UntypedFormControl(''),
        apellido: new UntypedFormControl(''),
        dniCuit: new UntypedFormControl(''),
        perfilAprobado: new UntypedFormControl(false),
        incluir12Cuotas: new UntypedFormControl(false),
    });

    tipoActualizacionOptions: SelectOption[] = [
        { codigo: 'IPC',    descripcion: 'IPC'  },
        { codigo: 'ICL',    descripcion: 'ICL'  },
        { codigo: 'MANUAL', descripcion: 'Fijo' },
        { codigo: 'OTRO',   descripcion: 'Otro' },
    ];

    currencyValuesAvailable?: SelectOption[] = [
        { codigo: 'ARS', descripcion: 'Pesos' },
        { codigo: 'USD', descripcion: 'Dolar' },
    ];

    updatePeriods: SelectOption[] = [
        { codigo: 1,  descripcion: 'Mensual'       },
        { codigo: 2,  descripcion: 'Bimestral'      },
        { codigo: 3,  descripcion: 'Trimestral'     },
        { codigo: 4,  descripcion: 'Cuatrimestral'  },
        { codigo: 6,  descripcion: 'Semestral'      },
        { codigo: 12, descripcion: 'Anual'          },
    ];

    quoteTypes: SelectOption[] = [
        { codigo: 'COMERCIAL', descripcion: 'Comercio' },
        { codigo: 'VIVIENDA', descripcion: 'Vivienda' },
    ];

    terms: SelectOption[] = [
        { codigo: 36, descripcion: '36 meses' }
    ];

    services: Service[] = [];
    selectedServices: Service[] = [];
    tiposFianza: TipoFianza[] = [];
    selectedTipoFianza: TipoFianza | null = null;
    zonas: Zona[] = [];
    tiposDescuento: TipoDescuento[] = [];
    tiposDescuentoFiltrados: TipoDescuento[] = [];
    selectedTipoDescuento: TipoDescuento | null = null;
    comerciales: Comercial[] = [];

    quoteResult?: Quote;
    commission?: Commission;
    serviceCategories: Category[] = [];
    user: User;
    offices?: Office[];

    constructor(
        private quotesService: QuotesService,
        private authService: AuthService,
        private propertiesService: PropertiesService,
        private officesService: OfficesService,
        private tiposFianzaService: TiposFianzaService,
        private zonasService: ZonasService,
        private tiposDescuentoService: TiposDescuentoService,
        private comercialesService: ComercialesService,
        private dialogRef: MatDialogRef<FastQuoteDialogComponent>,
        private router: Router,
        public utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.getOffices();
        this.loadZonas();
        this.loadTiposDescuento();
        this.loadTiposFianza('VIVIENDA', null);
        this.loadComerciales();
        this.preseleccionarMiComercial();
        this.quoteFG.controls.tipo.valueChanges.subscribe((newValue: QuoteType) => {
            this.updateValidators(newValue);
            this.quoteFG.controls.actualizacion.setValue('');
            this.quoteFG.controls.periodoActualizacion.setValue('');
            this.resetFianzaSelection();
            this.loadTiposFianza(newValue, this.quoteFG.value.idZona);
            if (newValue === 'VIVIENDA') {
                this.terms = [
                    { codigo: 36, descripcion: '36 meses' }
                ];
            } else {
                this.terms = [
                    { codigo: 12, descripcion: '12 meses' },
                    { codigo: 24, descripcion: '24 meses' },
                    { codigo: 36, descripcion: '36 meses' },
                    { codigo: 48, descripcion: '48 meses' }
                ];
            }
        });
        this.quoteFG.controls.oficina.valueChanges.subscribe((newOffice: Office) => {
            this.updateOfficeServices(this.user.tipo === 'OFICINA' ? this.user.oficina : this.user.tipo === 'AGENTE' ? this.user.agente?.oficina : newOffice);
        });
        this.user = this.authService.getUser();
        this.updateOfficeServices(this.user.tipo === 'OFICINA' ? this.user.oficina : this.user.tipo === 'AGENTE' ? this.user.agente?.oficina : undefined);
        this.updateValidators('VIVIENDA');
    }

    compare = (op1: string | undefined, op2: string | undefined) => op1 === op2;



    getOffices() {
        this.officesService.getOffices(0, 10000, [], {}).subscribe(response => {
            this.offices = response.body;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener oficinas', error.error?.descripcion));
    }

    updateOfficeServices(office?: Office) {
        this.services = [];
        office?.servicios?.forEach(serviceConfig => {
            if (serviceConfig.servicio.tipoProducto === 'GARANTIA' && !this.services.find(service => service.id === serviceConfig.servicio.id)) {
                this.services.push(serviceConfig.servicio);
            }
        });
        this.updateSelectedServicesFromFianza();
    }

    private loadZonas(): void {
        this.zonasService.getZonas(0, 100, [], { 'ocultar-inactivos': 'true' }).subscribe({
            next: response => this.zonas = response.body || [],
            error: () => this.zonas = []
        });
    }

    private loadTiposDescuento(): void {
        this.tiposDescuentoService.getTiposDescuento(0, 100, [], { 'ocultar-inactivos': 'true' }).subscribe({
            next: response => {
                this.tiposDescuento = response.body || [];
                this.tiposDescuentoFiltrados = [...this.tiposDescuento];
            },
            error: () => { this.tiposDescuento = []; this.tiposDescuentoFiltrados = []; }
        });
    }

    private loadTiposFianza(tipo: QuoteType, idZona: number | null): void {
        this.tiposFianzaService.getTiposFianza(0, 100, [], tipo as TipoProducto, true).subscribe({
            next: response => {
                const all = response.body || [];
                if (!idZona) {
                    this.tiposFianza = all.filter(f => !f.idZona);
                } else {
                    // Herencia de zona: prefer override, fallback a Default por clave
                    const claves = [...new Set(all.map(f => f.clave))];
                    this.tiposFianza = claves
                        .map(clave =>
                            all.find(f => f.clave === clave && f.idZona === idZona) ||
                            all.find(f => f.clave === clave && !f.idZona)
                        )
                        .filter((f): f is TipoFianza => !!f);
                }
            },
            error: () => this.tiposFianza = []
        });
    }

    onZonaChange(idZona: number | null): void {
        this.resetFianzaSelection();
        this.loadTiposFianza(this.quoteFG.value.tipo, idZona);
    }

    private resetFianzaSelection(): void {
        this.quoteFG.controls.idTipoFianza.setValue(null);
        this.selectedTipoFianza = null;
        this.selectedServices = [];
        this.selectedTipoDescuento = null;
        this.tiposDescuentoFiltrados = [...this.tiposDescuento];
        this.quoteFG.controls.idTipoDescuento.setValue(null);
        this.quoteFG.controls.porcentajeRenovacion.clearValidators();
        this.quoteFG.controls.porcentajeRenovacion.setValue('');
        this.quoteFG.controls.porcentajeRenovacion.updateValueAndValidity();
    }

    onFianzaChange(idFianza: number | null): void {
        this.selectedTipoFianza = idFianza
            ? (this.tiposFianza.find(f => f.id === idFianza) ?? null)
            : null;
        this.updateSelectedServicesFromFianza();

        // Filtrar tipos de descuento aplicables a esta fianza
        const ids = this.selectedTipoFianza?.idsTipoDescuento;
        this.tiposDescuentoFiltrados = ids?.length
            ? this.tiposDescuento.filter(td => ids.includes(td.id!))
            : [...this.tiposDescuento];

        // Limpiar tipo de descuento si ya no está disponible
        const currentDescuentoId = this.quoteFG.value.idTipoDescuento;
        if (currentDescuentoId && !this.tiposDescuentoFiltrados.find(td => td.id === currentDescuentoId)) {
            this.quoteFG.controls.idTipoDescuento.setValue(null);
            this.selectedTipoDescuento = null;
            this.quoteFG.controls.porcentajeRenovacion.clearValidators();
            this.quoteFG.controls.porcentajeRenovacion.setValue('');
            this.quoteFG.controls.porcentajeRenovacion.updateValueAndValidity();
        }
    }

    onTipoDescuentoChange(idTipoDescuento: number | null): void {
        this.selectedTipoDescuento = idTipoDescuento
            ? (this.tiposDescuentoFiltrados.find(td => td.id === idTipoDescuento) ?? null)
            : null;

        if (this.selectedTipoDescuento) {
            const topeMax = this.selectedTipoDescuento.tope ?? 100;
            this.quoteFG.controls.porcentajeRenovacion.setValidators([
                Validators.required, Validators.min(0), Validators.max(topeMax)
            ]);
        } else {
            this.quoteFG.controls.porcentajeRenovacion.clearValidators();
            this.quoteFG.controls.porcentajeRenovacion.setValue('');
        }
        this.quoteFG.controls.porcentajeRenovacion.updateValueAndValidity();
    }

    get mostrarPorcentajeRenovacion(): boolean {
        return !!this.selectedTipoDescuento;
    }

    get mostrarTipoCambio(): boolean {
        return this.quoteFG.value.monedaAlquiler === 'USD' || this.quoteFG.value.monedaExpensas === 'USD';
    }

    private updateSelectedServicesFromFianza(): void {
        if (!this.selectedTipoFianza) {
            this.selectedServices = [];
            return;
        }
        const codigos = SERVICIOS_POR_CLAVE[this.selectedTipoFianza.clave] || [];
        this.selectedServices = codigos
            .map(codigo => this.services.find(service => service.codigo === codigo))
            .filter((service): service is Service => !!service);
    }

    updateValidators(quoteType: QuoteType) {
        if (quoteType === 'COMERCIAL') {
            this.quoteFG.controls.actualizacion.setValidators([Validators.required]);
            this.quoteFG.controls.periodoActualizacion.setValidators([Validators.required]);
        } else {
            this.quoteFG.controls.actualizacion.setValidators([]);
            this.quoteFG.controls.periodoActualizacion.setValidators([]);
        }
        if (this.user.tipo === 'CORPORATIVO') {
            this.quoteFG.controls.oficina.setValidators([Validators.required]);
        } else {
            this.quoteFG.controls.oficina.setValidators([]);
        }
    }

    cerrarDialogo() {
      this.dialogRef.close();
    }

    quote() {
        if (!this.quoteFG.valid) return;

        const descuentoComercial: number | undefined = this.selectedTipoDescuento
            ? this.quoteFG.value.porcentajeRenovacion
            : undefined;

        this.quotesService.fastQuote({
            tipoProducto: this.quoteFG.value.tipoProducto,
            tipo: this.quoteFG.value.tipo,
            alquiler: this.quoteFG.value.alquiler,
            codigoMonedaAlquiler: this.quoteFG.value.monedaAlquiler,
            expensas: this.quoteFG.value.expensas,
            codigoMonedaExpensas: this.quoteFG.value.monedaExpensas,
            tipoCambio: this.quoteFG.value.tipoCambio || undefined,
            duracion: this.quoteFG.value.duracion,
            actualizacion: this.quoteFG.value.actualizacion,
            periodoActualizacion: this.quoteFG.value.periodoActualizacion,
            servicios: this.selectedServices,
            idOficina: this.user.tipo === 'OFICINA' ? this.user.oficina?.id : this.user.tipo === 'AGENTE' ? this.user.agente?.oficina?.id : this.quoteFG.value.oficina?.id,
            idAgente: this.user.tipo === 'AGENTE' ? this.user.agente?.id : undefined,
            idComercial: this.quoteFG.value.idComercial ?? undefined,
            descuentoComercial,
            nombre: this.quoteFG.value.nombre || undefined,
            apellido: this.quoteFG.value.apellido || undefined,
            dniCuit: this.quoteFG.value.dniCuit || undefined,
            perfilAprobado: this.quoteFG.value.perfilAprobado ?? false,
            incluir12Cuotas: this.quoteFG.value.incluir12Cuotas ?? false,
        }).subscribe(quote => {
            this.quoteResult = quote;
            this.serviceCategories = [];
            this.serviceCategories.push(this.mapServicesToCategory(quote.servicios));
        }, (error: ErrorResponse) => this.utilsService.alert('Error al realizar cotización', error.error?.descripcion));
        if (this.user?.agente?.id) {
            this.updateCommission(
                this.quoteFG.value.alquiler,
                this.quoteFG.value.expensas,
                this.user?.agente?.id,
                this.selectedServices,
                this.quoteFG.value.tipo,
                this.quoteFG.value.tipoProducto
            );
        }
    }

    mapServicesToCategory(services: QuotationService[]) {
        const servicesCategory = { name: 'Servicios ', items: [] };

        services.forEach(service => {
            servicesCategory.items.push({ value: service.nombre });
        });

        return servicesCategory;
    }

    updateCommission(alquiler: number, expensas: number, idAgente: ID, servicios: Service[], tipoCotizacion: QuoteType, tipoProducto: ProductType) {
        if (!idAgente) return;
        this.propertiesService.calculateCommission(alquiler, expensas, idAgente, servicios, tipoCotizacion, tipoProducto).subscribe(
            commission => this.commission = commission,
            (error: ErrorResponse) => this.utilsService.alert('Error al obtener comisión estimada', error.error?.descripcion)
        );
    }

    get mostrarInputCustom(): boolean {
        return this.quoteFG.value.tipoActualizacion === 'OTRO';
    }

    private loadComerciales(): void {
        this.comercialesService.getComerciales(0, 100, [], { 'ocultar-inactivos': 'true' }).subscribe({
            next: response => this.comerciales = response.body || [],
            error: () => this.comerciales = []
        });
    }

    private preseleccionarMiComercial(): void {
        this.comercialesService.getMiComercial().subscribe({
            next: response => {
                if (response.body?.id) this.quoteFG.controls.idComercial.setValue(response.body.id);
            },
            error: () => { /* el usuario no tiene comercial asignado, queda sin preseleccionar */ }
        });
    }

    reset() {
        this.quoteFG.setValue({
            oficina: '',
            tipoProducto: 'GARANTIA',
            tipo: 'VIVIENDA',
            idZona: null,
            idTipoFianza: null,
            alquiler: '',
            monedaAlquiler: 'ARS',
            expensas: '',
            monedaExpensas: 'ARS',
            tipoCambio: '',
            duracion: 36,
            actualizacion: null,
            periodoActualizacion: null,
            tipoActualizacion: 'MANUAL',
            tipoActualizacionCustom: '',
            idTipoDescuento: null,
            porcentajeRenovacion: '',
            idComercial: null,
            nombre: '',
            apellido: '',
            dniCuit: '',
            perfilAprobado: false,
            incluir12Cuotas: false,
        });
        this.quoteResult = undefined;
        this.commission = undefined;
        this.serviceCategories = [];
        this.selectedTipoFianza = null;
        this.selectedServices = [];
        this.selectedTipoDescuento = null;
        this.tiposDescuentoFiltrados = [...this.tiposDescuento];
        this.loadTiposFianza('VIVIENDA', null);
        this.updateValidators('VIVIENDA');
        this.preseleccionarMiComercial();
    }

    verCotizacion() {
        this.dialogRef.close();
        this.router.navigate(['cotizaciones', this.quoteResult.id]);
    }

}
